import type { API } from 'types/frontend/shared';

//
//
// template
//
//

// 수업 리포트 템플릿 신규 작성
export const CREATE_LESSON_REPORT_TEMPLATE = (academyId: number): API => ({
  method: 'POST',
  path: `/academy/${academyId}/lessonReport/template`,
});

// 수업 리포트 템플릿 목록
export const READ_LESSON_REPORT_TEMPLATE_LIST = (academyId: number): API => ({
  method: 'GET',
  path: `/academy/${academyId}/lessonReport/template`,
});

// 수업 리포트 템플릿 한개
export const READ_LESSON_REPORT_TEMPLATE = (academyId: number, templateId: number): API => ({
  method: 'GET',
  path: `/academy/${academyId}/lessonReport/template/${templateId}`,
});

export const DELETE_LESSON_REPORT_TEMPLATE = (academyId: number, templateId: number): API => ({
  method: 'DELETE',
  path: `/academy/${academyId}/lessonReport/template/${templateId}`,
});

//
//
// group
//
//
export const CREATE_LESSON_REPORT_GROUP = (academyId: number): API => ({
  method: 'POST',
  path: `/academy/${academyId}/lessonReport/group`,
});

export const UPDATE_LESSON_REPORT_GROUP = (academyId: number): API => ({
  method: 'PUT',
  path: `/academy/${academyId}/lessonReport/group`,
});

export const READ_LESSON_REPORT_GROUP_LIST = (academyId: number, summaryOnly?: true): API => ({
  method: 'GET',
  path: `/academy/${academyId}/lessonReport/group${summaryOnly ? '?summaryOnly=true' : ''}`,
});

// 리포트 그룹 보내기
export const DO_PUBLISH_LESSON_REPORT_GROUP = (academyId: number, groupId: number): API => ({
  method: 'POST',
  path: `/academy/${academyId}/lessonReport/group/${groupId}/publish`,
});

export const DELETE_LESSON_REPORT_GROUP = (academyId: number, groupId: number): API => ({
  method: 'DELETE',
  path: `/academy/${academyId}/lessonReport/group/${groupId}`,
});

//
//
// student side
//
//

// 학생/학부모용 - 수업 리포트 목록
export const READ_LESSON_REPORT_LIST_OF_USER = (academyId: number, cursor?: string): API => ({
  method: 'GET',
  path: `/academy/${academyId}/lessonReport/user${
    cursor !== null && cursor !== undefined ? `?cursor=${encodeURIComponent(String(cursor))}` : ''
  }`,
});

//
//
// teacher side
//
//

// 교사용 - 특정 학생의 수업 리포트 목록
export const READ_LESSON_REPORT_LIST_OF_STUDENT = (
  academyId: number,
  studentId: number,
  cursor?: string,
): API => ({
  method: 'GET',
  path: `/academy/${academyId}/lessonReport/student/${studentId}${
    cursor ? `?cursor=${encodeURIComponent(String(cursor))}` : ''
  }`,
});
